import { styled } from '@linaria/react';

/**
 * Label card for clickable nodes (agent sessions, turns, "+N more"). Hover and
 * selected states need pseudo-classes, so they live here instead of in inline styles.
 */
const ClickableLabel = styled.div<{ $color: string; $selected: boolean }>`
  cursor: pointer;
  pointer-events: auto;
  background: ${({ $selected }) => ($selected ? 'var(--secondary-lightest)' : '#fafafa')};
  border: 1px solid ${({ $color }) => $color};
  box-shadow: ${({ $color, $selected }) => ($selected ? `0 0 0 2px ${$color}` : 'none')};
  transition: background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background: var(--secondary-lightest);
    box-shadow: ${({ $color, $selected }) => ($selected ? `0 0 0 2px ${$color}` : '0 2px 6px rgba(0, 0, 0, 0.15)')};
  }

  &:focus-visible {
    outline: 2px solid var(--secondary-base);
    outline-offset: 2px;
  }
`;

/**
 * Focus ring for commit cards, which take keyboard focus to open their preview;
 * matches the ring on the clickable cards.
 */
const FocusableCard = styled.div`
  &:focus-visible {
    outline: 2px solid var(--secondary-base);
    outline-offset: 2px;
  }
`;

/**
 * Show/hide-turns pill hung just under a session card. It is a sibling of the
 * card rather than a child so the two buttons never nest.
 */
const TurnToggle = styled.button<{ $color: string }>`
  position: absolute;
  top: calc(100% + 3px);
  left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px 8px 1px 4px;
  font: 500 10px/1.4 'Figtree', sans-serif;
  color: ${({ $color }) => $color};
  white-space: nowrap;
  background: var(--base-white);
  border: 1px solid ${({ $color }) => $color};
  border-radius: 10px;
  cursor: pointer;
  pointer-events: auto;
  transition: background 0.15s ease;

  &:hover {
    background: var(--secondary-lightest);
  }

  &:focus-visible {
    outline: 2px solid var(--secondary-base);
    outline-offset: 2px;
  }
`;

export { ClickableLabel, FocusableCard, TurnToggle };
